module.exports = __webpack_public_path__ + "img/symbol_1.560edf65.png";